var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isTruncated
    ? _c(_setup.LexonTooltipComponent, {
        staticClass: "tooltip-activator caso1",
        attrs: {
          message: _setup.generateTooltipMessage(_setup.props.item),
          position: "top",
          isWidthAuto: "",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "activator-element",
              fn: function () {
                return [
                  Array.isArray(_setup.props.item.data)
                    ? _c(
                        "div",
                        [
                          _c(_setup.PhoneListComponent, {
                            attrs: {
                              label: _setup.props.item.label,
                              data: _setup.props.item.data,
                              index: _vm.index,
                            },
                            on: { setRef: _setup.onSetRef },
                          }),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "row-info" }, [
                        _c("span", { staticClass: "info-item-label" }, [
                          _vm._v(_vm._s(`${_setup.props.item.label}:`)),
                        ]),
                        _c(
                          "div",
                          {
                            ref: (el) => _setup.onSetRef(el, _vm.index),
                            staticClass: "info-item-data-large",
                          },
                          [_vm._v(_vm._s(_vm.item.data))]
                        ),
                      ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          3419348018
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }